import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlayerApiService } from '../../services/player-api.service';
import { PlayerDataService } from '../../services/player-data.service';
import { UtilsService } from '../../services/utils.service'
import { Router } from '@angular/router';

@Component({
  selector: 'people-decisions',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,   // <-- make sure FormsModule is listed here

  ],
  templateUrl: './people-decisions.component.html',
  styleUrl: './people-decisions.component.css'
})
export class PeopleDecisionsComponent implements OnInit {

  PeopleD: any = null;
  //RO: any = null;
  //validationError = '';

  constructor(private router: Router, private api: PlayerApiService, private playerData: PlayerDataService, private utils: UtilsService) { }

  async ngOnInit() {
    this.PeopleD =
      (await this.playerData.getPageDecisionData('people')) || {
        ProductionStaff: 0,
        SalesStaff: 0,
        ServiceCenterStaff: 0,
        AvgMonthlyWages: 0,
        SkillTrainingExpenses: 0,
        ManagementTraining: 0

      };
    console.log("In people init");
    console.log(this.PeopleD);
    //const roCached = await this.playerData.getPageDecisionData('readonly') || { "RoundSubUnit": "", "APARselectarr": "[]", "maxProducts": 0, "PlatformSelectvals": [] };
    //this.RO = roCached;
    //console.log(this.RO);
  }

  onInputChange() {
    this.playerData.setPageDecisionData('people', this.PeopleD);
  }
}